import ComputerMonitorSvg from '../../images/ComputerMonitorSvg'

export function NotChromeState(props) {
	return <div className="edge-case-state">
		<ComputerMonitorSvg/>
		<h3>Please use Google Chrome to access your dashboard</h3>
	</div>
}

export default NotChromeState